import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createStudent } from '@services/registry';

export function useCreateStudent({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ email, password, profile }) => {
            return await createStudent({ tenantId, email, password, profile });
        },
        onSuccess: () => {
            // Subscriptions already keep UI fresh; this is here for future query usage.
            qc.invalidateQueries({ queryKey: ['students', tenantId] });
            qc.invalidateQueries({ queryKey: ['studentKpis', tenantId] });
        },
    });
}

